import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import { open, close } from "../redux/popupSlice";

import Popup01 from "../pages/popup/Popup01"
import Popup02 from "../pages/popup/Popup02"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import HLSVideo from '../libs/hlsVideo';


import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';


import Price from './support/Price';
import CountryLanguagePopup from '../components/country';
import { send } from '@emailjs/browser';
import { logIn, logOut, setData } from '../redux/usersSlice';
import moment from 'moment';
import Cookies from 'js-cookie';
import { initGA, logPageView, logEvent, gtag } from '../analytics';

export default function Main() {
    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const location = useLocation();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const swiperRef = useRef(null);

    const [swiperSpeed, setSwiperSpeed] = useState(3000);

    const [videoSample, setVideoSample] = useState(['Modeling', 'UV Editing', 'Painting', 'Rigging and Skinning', 'Unity Integrated Environment', 'Pro Extension Features', 'Generative AI Utilization', 'Library']);
    const [videoSamplefiles, setvideoSamplefiles] = useState(['polygonmodeling', 'front_UV', 'painting', 'RiggingandSkinning', 'UnityIntegratedEnvironment', 'front_Pro', 'GenerativeAIUtilization', 'ArtPass']);
    const [videoSamplethum, setvideoSamplethum] = useState(['front_model_thum', 'front_UV_thum', 'front_painting_thum', 'front_rig_thum', 'front_unity_thum', 'front_Pro_thum', 'front_ai_thum', 'front_lb_thum']);
    const [urlSample, setURLSample] = useState(['main', 'prifile', 'Painting', 'Rigging and Skinning', 'Unity Integrated Environment', 'Pro Extension Features', 'Generative AI Utilization', 'Library']);
    const [isPlaying, setIsPlaying] = useState(false);
    const [SampleComment, setSampleComment] = useState([
        'Work on any shape you desire, from low-poly to high-poly, within Unity.',
        'Unwrap 3D models into 2D to apply precise textures.',
        'Paint textures freely directly on the 3D model or on its unwrapped 2D surface.',
        'Bring your 3D models to life with rigging mode.',
        'Fully compatible with the latest Unity 6.',
        'Explore all the latest features available exclusively in Pro.',
        'Edit generated 3D models or apply images as textures.',
        'Boost productivity with high-quality assets.'
    ]);

    const video_slide = 6;
    const video_slide_art_pass = 5;

    const modules = [FreeMode];
    if (video_slide >= 6) {
        modules.push(Autoplay);
    }

    const reivew_top_sample = [
        'WinterboltGames',
        'Thurtwings',
        'heyitsjayy',
        'Timps',
        'Oranor76',
        'Tinman_',
        'heyitsjayy',
        'TabArtwork',
        'x4000',
        'JarlBalgruuftheGreater',
        'Pascal-NL',
        'jesusluvsyooh',
        'nathanouzts',
        'alexgamble'
    ];
    const reivew_btm_sample = [
        'combatsheep',
        'Zaddo',
        'PhogHcDev',
        'restush96',
        'ACABerryGames',
        'Turbo13',
        'Merchant1307',
        'Qxlbr',
        'JTAGames',
        'igorshmigor',
        'Tech-Labs',
        'Blood_Working_',
        'rwmtiger',
        'Caetleo'
    ];
    const reivew_top_sample_comment = [
        `Your Must Be Completely BOLLOCKS If You Don't Buy This One!`,
        'What a wonderful tool! 10* out of 5',
        'Intuitive and effective modeling tool within Unity',
        'Worth every cent. And at least 5 stars',
        'Tired of switching between your 3D modeler and Unity? Get this now!',
        'Superb modeling tool !!!',
        'Intuitive and effective modeling tool within Unity',
        'Easy to use and super useful!',
        'Shockingly Good.',
        'Best modeling tool in Unity',
        'Perfect modeler in Unity',
        'Reignited my passion for 3D Modelling!',
        'The Best Asset I Have',
        'Absolutely Brilliant'
    ];
    const reivew_btm_sample_comment = [
        'There is no other great modeling asset like this in Unity Asset Store',
        'Fantastic tool, even if you have no modeling experience',
        'The Best Assets for indie game developer',
        'The Best Initiative Modeling Tool (Alternative Blender & Maya)',
        'AMAZING Modeling ASSET!',
        'The best asset for 3D modeling in Unity',
        `It's like this guy is an Autodesk coder.`,
        'Unity should have integrated this instead of ProBuilder',
        '10x Better than pro-builder. Should have bought a long time ago',
        'Impressive tool for modeling and texturing right within Unity',
        'Excellent tool - Solid alternative to ProBuilder',
        'Must-have tool for every indie developer',
        'This is Great! Where has this been all my life!',
        'Blender in Unity. Huge time saver.'
    ];


    const partner_top_sample = 6;
    const partner_btm_sample = 6;

    const [planOther1, setPlanOther1] = useState(false);
    const [planOther2, setPlanOther2] = useState(false);

    const [routesSample, setRoutesSample] = useState([
        routes.PModeling,
        routes.UV_Editing,
        routes.Painting,
        routes.Rigging,
        routes.Intergration,
        routes.Extension,
        routes.AI,
        routes.Library
    ]);

    const [isEmpty, setIsEmpty] = useState(false);

    /* useEffect(() => {
        window.scrollTo(0, 0);
    }, []); */

    useEffect(() => {
        if (lang === 0) {
            setVideoSample(['폴리곤 모델링', 'UV 에디팅', '페인팅', '리깅과 스키닝', '유니티 통합환경', 'Pro 확장 기능', '생성형 AI 활용', '템플릿 라이브러리']);
            setSampleComment([
                '유니티 내에서 로우 폴리부터 하이 폴리까지 원하는 형태를 작업하세요.',
                '3D를 2D로 펼쳐 정확한 텍스처를 입히세요.',
                '3D 모델 위에 직접 혹은 2D로 펼쳐서 자유롭게 텍스쳐를 그리세요.',
                '리깅 모드로 3D 모델에 생명력을 불어넣으세요.',
                '최신 유니티 6까지 완벽히 호환됩니다.',
                'Pro에서만 제공되는 최신 기능을 모두 만나보세요.',
                '생성된 3D 모델을 편집하거나 이미지를 텍스처로 적용시키세요.',
                '고품질 에셋을 활용하여 더욱 생산성을 높여보세요.'
            ])
        } else {
            setVideoSample(['Polygon Modeling', 'UV Editing', 'Painting', 'Rigging & Skinning', 'Unity Integration', 'Pro Extension Features', 'Gen AI Utilization', 'Template Library']);
            setSampleComment([
                'Create from low-poly to <br> high-poly in Unity.',
                'Unwrap 3D to 2D <br> and apply precise textures.',
                'Paint textures freely on 3D <br> or unwrapped 2D.',
                'Bring 3D models to life <br> with rigging mode.',
                'Fully compatible <br> with up to Unity 6.',
                'Access all the latest features <br> exclusive to UModeler X Pro.',
                'Edit generated 3D models <br> or apply images as textures.',
                'Boost productivity <br> with high-quality 3D assets.'
            ]);
        }
    }, [lang]);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width >= 1400) {
                setSwiperSpeed(5000);
            } else if (width >= 1000) {
                setSwiperSpeed(5000);
            } else {
                setSwiperSpeed(5000)
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const testFunc = async () => {
        await API.post('v1/auth/config').then(({ data }) => {
            /* console.log('data', data); */
        }).catch(err => {
            /* console.log(err.response.data) */
        })
    }


    const [popupOpen, setPopupOpen] = useState(false);

    const country = useSelector((state) => state.locationReducer.country.value);
    const language = useSelector((state) => state.locationReducer.language.value);

    useEffect(() => {
        if (
            mbData &&
            (mbData.idx > 0) &&
            (
                (!mbData.countryCode || mbData.countryCode.length === 0)
            )
        ) {
            setPopupOpen(true);
        }
    }, [mbData]);

    useEffect(() => {
        if (!mbData || !mbData.idx) {
            const fetchUserProfile = async () => {
                try {
                    const response = await API.get('auth/me', {}, true);
                    const data = response.data;
                    if (data?.msg) {
                        if (data.msg === 'err4') {
                            try {
                                await API.post('auth/logout', {}, true);
                            } catch (err) {
                                console.error(err);
                            }
                            dispatch(logOut());
                            dispatch(setData({}));
                            dispatch(open({
                                component:
                                    <Popup01
                                        max_width={'300px'}
                                        text1={lang === 0 ? '탈퇴한 이메일 주소입니다.' : 'This email address has been withdrawn.'}
                                        button={lang === 0 ? '확인' : 'OK'}
                                    />
                            }));
                        }
                    } else {
                        dispatch(
                            logIn({
                                mbData: {
                                    idx: data?.id,
                                    mb_type: data?.validType,
                                    mb_email: data?.email,
                                    mb_name: data?.fullname,
                                    lang: data?.language === 'ko' ? 0 : 1,
                                    countryCode: data?.countryCode,
                                    isAcceptMarketingActivities: data?.isAcceptMarketingActivities,
                                    emailLanguage: data?.emailLanguage,
                                },
                                autoLogin: moment(),
                            })
                        );
                    }
                } catch (error) {
                    console.error("User not logged in or token expired", error);
                }
            };

            fetchUserProfile();
        }
    }, []);

    useEffect(() => {
        const startTime = Date.now();
        
        return () => {
            const endTime = Date.now();
            const timeSpent = Math.round((endTime - startTime) / 1000);
            
            logEvent(
                'Page',
                'Time Spent',
                'Main Page',
                mbData?.idx,
                { time_seconds: timeSpent }
            );
        };
    }, []);

    useEffect(() => {
        // 예시: API 호출 결과나 다른 조건에 따라 isEmpty 설정
        const checkIsEmpty = async () => {
            try {
                const result = await API.get('some/endpoint');
                setIsEmpty(result.data.isEmpty);
            } catch (error) {
                setIsEmpty(true);  // 에러 발생 시 기본값
            }
        };
        
        checkIsEmpty();
    }, []);

    return (
        <>
            <div className="main_back">
                <div className="main_part main_banner">
                    <div className="video_view main">
                        <div className="banner_text_box">
                            <p>Finish 3D in Unity</p>

                            <button
                                className="custom_btn"
                                type="button"
                                onClick={() => {
                                    gtag('event', 'try_free_click', {
                                        'event_category': 'engagement',
                                        'event_label': lang === 0 ? '무료로 사용해보기(Header)' : 'Try it for free(Header)'
                                    });
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 사용해보기' : 'Try it for free'}
                            </button>
                        </div>

                        <div className="banner_btm_box">
                            <div className="box none_logo">
                                <p>25K+</p>
                                <div className="sub">
                                    <span>25K+ Users across</span>
                                    <span>150+ Countries</span>
                                </div>
                            </div>

                            <div className="box img none_logo">
                                <img src={require("../assets/icon/header_unity.svg").default} />
                            </div>

                            <div className="box none_logo">
                                <p>Finalist</p>
                                <div className="sub">
                                    <span>Unitiy Awards 2024</span>
                                    <span>Best Artistic Tool</span>
                                </div>
                            </div>
                        </div>


                        <HLSVideo
                            width="100%"
                            height="100%"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster={require("../assets/thumnails/front_main_thum.webp")}
                            src={"/m3u8/Sizzle_Reel.m3u8"}
                        >
                            소개 영상입니다.
                        </HLSVideo>

                        <div className="dark"></div>
                    </div>
                </div>

                <div className="main_part padding">
                    <div className="title_box title_pc">
                        {lang === 0 ?
                            <>
                                3D 모델링, 텍스처링, 리깅을 모두 유니티에서
                            </>
                            :
                            'Model, Rig and Paint in Unity'
                        }
                    </div>

                    <div className="title_box title_mobile">
                        {lang === 0 ?
                            <>
                                3D 모델링, 텍스처링, 리깅을 모두 유니티에서
                            </>
                            :
                            'Model, Rig and Paint in Unity'
                        }
                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ? '모든 3D 작업을 유니티에서 통합하고, 실시간으로 결과를 확인하며 차원이 다른 작업 속도를 경험하세요.' : 'Bring your 3D creations into Unity, review instantly, and save time and resources.'}
                    </div>

                    <div className="video_sample_list_box">
                        {videoSample.map((x, i) => (
                            <div
                                key={i}
                                className={`sample_video`}
                                onMouseEnter={(e) => {
                                    /* const video = e.currentTarget.querySelector('video');
                                    if (!isPlaying) {
                                        video.play().catch(error => {
                                            console.error('Playback failed:', error);
                                        });
                                        setIsPlaying(true);
                                    } */
                                }}
                                onMouseLeave={(e) => {
                                    /* const video = e.currentTarget.querySelector('video');
                                    video.pause();
                                    video.currentTime = 0;
                                    setIsPlaying(false); */
                                }}
                                /* onClick={(e) => {
                                    const video = e.currentTarget.querySelector('video');
                                    const videoSrc = video.querySelector('source').src;

                                    dispatch(open({
                                        component: 
                                            <Popup01 
                                                x_btn={true}
                                                sample_video={true}
                                                max_width={'800px'}
                                                sample_video_src={videoSrc}
                                            />
                                    }));
                                }} */
                                onClick={() => {
                                    navigate(routesSample[i]);
                                }}
                            >
                                <div className="video_view">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={require("../assets/thumnails/" + videoSamplethum[i] + ".webp")}
                                        src={'/m3u8/' + videoSamplefiles[i] + '.m3u8'}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>

                                    <div className={`search_back`}>
                                        <img src={require("../assets/icon/Search.svg").default} />
                                    </div>
                                </div>
                                <p className="title">{x}</p>
                                <div className="sub_title" dangerouslySetInnerHTML={{ __html: SampleComment[i] }}></div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="main_part padding">
                    <div className="title_box">
                        {lang === 0 ?
                            <>
                                그리기와 밀고 당기기만으로 완성하는 프로토타입
                            </>
                            :
                            'Quickly Create Prototypes'
                        }

                    </div>
                    <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                스케치업 스타일의 그리기와 밀고 당기는 간단한 조작만으로, 누구나 손쉽게 자유롭게 3D 월드를 만들 수 있어요.
                            </>
                            :
                            'With SketchUp-style drawing and simple push-and-pull modeling, anyone can easily and freely create a 3D world.'
                        }

                    </div>
                    <button
                        type="button"
                        className="art_pass_btn game_dev"
                        onClick={() => {
                            navigate(routes.Modeling);
                        }}
                        style={{
                            marginTop: 20, marginBottom: 20
                        }}
                    >
                        {lang === 0 ? '자세히 알아보기' : 'Learn more'}
                    </button>
                    <div className="tool_box" style={{ marginTop: 40 }}>
                        <div
                            className={`search_back`}
                            onClick={() => {
                                navigate(routes.Modeling);
                            }}
                        >
                            <img src={require("../assets/icon/Search.svg").default} />
                        </div>
                        <div className="video_view" >

                            <HLSVideo
                                width="100%"
                                height="100%"
                                autoPlay
                                muted
                                loop
                                playsInline
                                poster={require("../assets/thumnails/front_sketch_thum.webp")}
                                src={'/m3u8/SketchUpstylemodeling.m3u8'}
                                style={{ borderRadius: 20 }}
                            >
                            </HLSVideo>

                        </div>
                    </div>
                </div>

                <div className="main_part padding">
                    <div className="title_box">
                        {lang === 0 ?
                            <>
                                어렵고 복잡한 3D 툴과 작별할 시간
                            </>
                            :
                            '3D tool for everyone, not just artists.'
                        }
                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                UModeler X는 숙련된 아티스트는 물론, 3D 모델링에 익숙하지 않은 레벨 디자이너, 기획자, 프로그래머도 손쉽게 사용할 수 있는 툴입니다.
                                <br />여러분은 상상력을 구현하는 데에만 집중하세요. 나머지는 UModeler X가 도와드립니다.
                            </>
                            :
                            'UModeler X is easy to use for everyone, from level designers and game designers to programmers and artists.'
                        }
                    </div>

                    <button
                        type="button"
                        className="art_pass_btn game_dev"
                        onClick={() => {
                            navigate(routes.GameDev);
                        }}
                        style={{
                            marginTop: 20, marginBottom: 20
                        }}
                    >
                        {lang === 0 ? '자세히 알아보기' : 'Learn more'}
                    </button>

                    <div className="tool_box" style={{ marginTop: 40 }}>
                        <img src={require("../assets/Front_Solution.webp")} style={{ borderRadius: 20 }} />
                    </div>

                </div>

                <div className="main_part">
                    <div className="title_box">
                        {lang === 0 ? '활용 사례' : 'Use Cases'}
                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ? 'UModeler 제품의 활용 가능성을 직접 확인해 보세요!' : "Explore UModeler's full potential—see it in action yourself!"}
                    </div>

                    <button
                        type="button"
                        className="art_pass_btn game_dev"
                        onClick={() => {
                                window.open('https://youtu.be/CG6ZZv3f2L4?si=qcrNuZX7WS5A5hju');
                        }}
                        style={{
                            marginTop: 20, marginBottom: 20
                        }}
                    >
                        {lang === 0 ? '직접 확인하기' : 'Check it out'}
                        <img className="navi" width={30} src={require("../assets/icon/navi_icon.svg").default} />
                    </button>

                    <div className="tool_box" style={{ marginTop: 40, maxWidth: '100%' }}>
                        <img src={require("../assets/usecase.webp")} />
                    </div>
                </div>

                <div className="main_part">
                    <div className="title_box">
                        {lang === 0 ?
                            <>
                                시작이 부담 되시나요?
                            </>
                            :
                            'Get started with ease.'
                        }

                    </div>

                    <div className="sub_title_box part3">
                        {lang === 0 ?
                            <>
                                UModeler X의
                            </>
                            :
                            "UModeler X's"
                        }

                        <b
                            onClick={() => {
                                if (lang === 0) {
                                    window.open('https://docs.umodeler.com/ko/docs/intro');
                                } else {
                                    window.open('https://docs.umodeler.com/docs/intro');
                                }
                            }}
                        >
                            {lang === 0 ?
                                <>
                                    공식 매뉴얼
                                </>
                                :
                                'official manual'
                            }
                            <img className="navi" width={30} src={require("../assets/icon/navi_icon.svg").default} />
                        </b>
                        {lang === 0 ?
                            <>
                                과 다양한 교육 자료로 쉽고 빠르게 적응을 도와드리겠습니다.
                            </>
                            :
                            'and various learning resources help you apply it quickly and easily.'
                        }
                    </div>

                    <div className="video_slide_box">
                        <Swiper
                            modules={[Autoplay]}
                            slidesPerView={'auto'}
                            loop={true}
                            freeMode={false}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                            }}
                            speed={5000}
                            style={{
                                overflow: 'unset'
                            }}
                        >
                            {[
                                { links: 'https://www.youtube.com/watch?v=dvusbq7o6jo', ycodes: 'dvusbq7o6jo', subjects: "[Beginner's Tutorial] LowPoly Table and Chair" },
                                { links: 'https://www.youtube.com/watch?v=wYPISerxOys', ycodes: 'wYPISerxOys', subjects: "[Beginner's Tutorial] LowPoly Tower" },
                                { links: 'https://www.youtube.com/watch?v=EOUHbMZC5TU', ycodes: 'EOUHbMZC5TU', subjects: "[Beginner's Tutorial] Lowpoly Building" },
                                { links: 'https://www.youtube.com/watch?v=a57fFqkEoh4', ycodes: 'a57fFqkEoh4', subjects: "[Beginner's Tutorial] Isometric Room" },
                                { links: 'https://www.youtube.com/watch?v=SDs8Y5DCT4Y', ycodes: 'SDs8Y5DCT4Y', subjects: "[Creation Guide] Sunny Hill Village" },
                                { links: 'https://www.youtube.com/watch?v=53rFgSVLwMM', ycodes: '53rFgSVLwMM', subjects: "[Beginner's Tutorial] UModeler X - Basics" },
                                { links: 'https://www.youtube.com/watch?v=--loU3ihpTc', ycodes: '--loU3ihpTc', subjects: "[Beginner's Tutorial] UModeler X - UV Editor" },
                                { links: 'https://www.youtube.com/watch?v=WTwY8zqnEMw', ycodes: 'WTwY8zqnEMw', subjects: "[Beginner's Tutorial] UModeler X - Zepeto basic" },
                                { links: 'https://www.youtube.com/watch?v=ijzOx4gXS7k', ycodes: 'ijzOx4gXS7k', subjects: "[Beginner's Tutorial] UModeler X - Intro to UI" },
                                { links: 'https://www.youtube.com/watch?v=iuEbvrONlBU', ycodes: 'iuEbvrONlBU', subjects: "[Beginner's Tutorial] UModeler X - Rigging" },
                                { links: 'https://www.youtube.com/watch?v=NMYy8VcstUI', ycodes: 'NMYy8VcstUI', subjects: "[Demo] Synty Studios Character Animation" }
                            ].map((x, i) => (
                                <SwiperSlide
                                    key={i}
                                >
                                    <div
                                        className={`sample_video`}
                                        onClick={() => {
                                            window.open(x?.links);
                                        }}
                                    >
                                        <div className="video_view">
                                            <img src={`https://img.youtube.com/vi/${x?.ycodes}/maxresdefault.jpg`} style={{ borderRadius: 20 }} />
                                            {/* <video 
                                                width="100%" 
                                                height="100%" 
                                                autoPlay
                                                muted 
                                                loop
                                                playsInline
                                            >
                                                <source src={require("../assets/test_video.mp4")} type="video/mp4" />
                                                소개 영상입니다.
                                            </video> */}
                                        </div>
                                        <div className="sub_title">
                                            {x?.subjects}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>

                <div className="main_part art_pass">
                    <div className="title_box">
                        {lang === 0 ?
                            <>
                                함께 제공되는 고품질 템플릿
                            </>
                            :
                            <>
                                High-quality templates included
                            </>
                        }


                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ?
                            <>
                                Pro를 구독하고 여러분의 작업을 도울 고품질 3D 템플릿들을 만나보세요.
                                <br />100만원 상당의 고품질 템플릿을 자유롭게 활용하여 내 작업물의 완성도를 높이고 작업 속도를 단축시킬 수 있습니다!
                            </>
                            :
                            <>
                                Subscribe to Pro and unlock high-quality 3D templates to supercharge your work.
                                <br />Freely use premium templates worth $700 USD to enhance the quality of your creations and speed up your workflow!
                            </>
                        }
                    </div>

                    <button
                        type="button"
                        className="art_pass_btn game_dev"
                        onClick={() => {
                            navigate(routes.Library);
                        }}
                        style={{
                            marginTop: 20, marginBottom: 20
                        }}
                    >
                        {/* {lang === 0 ? '에셋 목록 확인하기' : 'View Asset List'} */}
                        {lang === 0 ? '자세히 알아보기' : 'Learn More'}
                    </button>

                    <div className="video_slide_container">
                        <div className="video_slide_track art_pass">
                            {[
                                "cathedeal.jpg",
                                "robot.png",
                                "train.jpg",
                                "farm.jpg",
                                "losttemple.jpg",
                                "sunnyhillvillage.jpg",
                                "island.jpg",
                                "medievaltown.jpg",
                                "dungeon.jpg",
                                "rivercity.jpg",
                                "pasteltown.jpg",
                            ].map((x, i) => (
                                <div className="video_slide_item art_pass" key={i}>
                                    <div className="video_view">
                                        <img src={require("../assets/artpass/" + x + "")} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="video_slide_container sub">
                        <div className="video_slide_track sub art_pass">
                            {[
                                "weapon.jpg",
                                "neoncity.jpg",
                                "witchscauldrun.jpg",
                                "moonglowvillage.jpg",
                                "warmdreamroom.jpg",
                                "blacksmith.jpg",
                                "monobeigeroom.jpg",
                                "livingKitchenLounge.jpg",
                                "turtleship.jpg",
                                "sunsettrain.jpg",
                                "isometricroom.jpg"
                            ].map((x, i) => (
                                <div className="video_slide_item art_pass" key={i}>
                                    <div className="video_view">
                                        <img src={require("../assets/artpass/" + x + "")} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="main_part">
                    <div className="title_box">
                        {lang === 0 ? '전 세계가 인정한 유니티의 검증된 솔루션' : 'Verified by Unity, Built for Developers'}
                    </div>

                    <div className="sub_title_box">
                        {lang === 0 ? '150여 개국 25,000명 이상의 사용자의 찬사를 받은 검증된 유니티 3D 솔루션을 직접 경험해 보세요.' : 'Experience a verified Unity 3D solution trusted by 25,000+ developers in 150+ countries.'}
                    </div>
                    <div className="tool_box" style={{ marginTop: 40, maxWidth: '100%' }}>
                        <img src={require("../assets/review.png")} />
                    </div>
                    {/* <div className="video_slide_container">
                        <div className="video_slide_track art_pass review">
                            {reivew_top_sample.map((x, i) => (
                                <div className="video_slide_item art_pass review" key={i}>
                                    <div className="review_profile slide_review">
                                        <img src={require("../assets/icon/profile_none.svg").default} />
                                        <div className="text_box">
                                            <p>{x}</p>
                                        </div>
                                    </div>

                                    <div className="comment_box slide_review">
                                        <div className="review_star">
                                            {[...Array(5)].map((x, i) => (
                                                <img src={require("../assets/icon/star-fill.svg").default} key={i}/>
                                            ))}
                                        </div>
                                        <div className="comment">
                                            코멘트 입니다. 코멘트 입니다. 코멘트 입니다. 코멘트 입니다. 코멘트 입니다. 코멘트 입니다.{i}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {reivew_top_sample.map((x, i) => (
                                <div className="video_slide_item art_pass review" key={`clone-${i}`}>
                                    <div className="review_profile slide_review">
                                        <img src={require("../assets/icon/profile_none.svg").default} />
                                        <div className="text_box">
                                            <p>{x}</p>
                                        </div>
                                    </div>

                                    <div className="comment_box slide_review">
                                        <div className="review_star">
                                            {[...Array(5)].map((x, i) => (
                                                <img src={require("../assets/icon/star-fill.svg").default} key={i}/>
                                            ))}
                                        </div>
                                        <div className="comment">
                                            코멘트 입니다. 코멘트 입니다. 코멘트 입니다. 코멘트 입니다. 코멘트 입니다. 코멘트 입니다.{i}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div> */}

                    {/* <div className="video_slide_box sample_review">
                        <Swiper
                            modules={[Autoplay]}
                            slidesPerView={'auto'}
                            loop={true}
                            freeMode={false}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                            }}
                            speed={15000}
                            spaceBetween={20}
                            allowTouchMove={false}

                            style={{
                                overflow: 'unset'
                            }}
                        >
                            {reivew_top_sample.map((x, i) => (
                                <SwiperSlide
                                    key={i}
                                >
                                    <div
                                        className={`sample_review_card`}
                                    >
                                        <div className="review_profile">
                                            <img src={require("../assets/icon/profile_none.svg").default} />
                                            <div className="text_box">
                                                <p>{x}</p>
                                            </div>
                                        </div>

                                        <div className="comment_box">
                                            <div className="review_star">
                                                {[...Array(5)].map((x, i) => (
                                                    <img src={require("../assets/icon/star-fill.svg").default} key={i} />
                                                ))}
                                            </div>
                                            <div className="comment">
                                                {reivew_top_sample_comment[i]}
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    <div className="video_slide_box sample_review" style={{ marginTop: '20px' }}>
                        <Swiper
                            modules={[Autoplay]}
                            slidesPerView={'auto'}
                            loop={true}
                            freeMode={false}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                                reverseDirection: true,
                            }}
                            speed={15000}
                            spaceBetween={20}
                            allowTouchMove={false}

                            style={{
                                overflow: 'unset'
                            }}
                        >
                            {reivew_btm_sample.map((x, i) => (
                                <SwiperSlide
                                    key={i}
                                >
                                    <div
                                        className={`sample_review_card`}
                                    >
                                        <div className="review_profile">
                                            <img src={require("../assets/icon/profile_none.svg").default} />
                                            <div className="text_box">
                                                <p>{x}</p>
                                            </div>
                                        </div>

                                        <div className="comment_box">
                                            <div className="review_star">
                                                {[...Array(5)].map((x, i) => (
                                                    <img src={require("../assets/icon/star-fill.svg").default} key={i} />
                                                ))}
                                            </div>
                                            <div className="comment">
                                                {reivew_btm_sample_comment[i]}
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div> */}
                </div>

                

                <div className="main_part padding">
                    <div className="title_box">
                        {lang === 0 ?
                            <>
                                <span>UModeler X Pro</span>로<br />모든 기능을 제한 없이 활용하세요
                            </>
                            :
                            <>
                                <span>Go Pro</span><br />Unlock All Features & Tools
                            </>
                        }
                    </div>

                    <button
                        type="button"
                        className="price_btn"
                        onClick={() => {
                            navigate(routes.Price);
                        }}
                        style={{
                            marginTop: 40, marginBottom: 40
                        }}
                    >
                        {lang === 0 ? '자세히 알아보기' : 'Learn more'}
                    </button>


                    <div className="main_price_box main_page">
                        <div className="price_tab fill main other sub" style={{ borderRadius: '20px 0 0 20px' }}>
                            <p className="title top_set none"></p>
                            {/* <span className="sub_title">상업적 이용</span> */}
                            <span className="sub_title">
                                {lang === 0 ? '로우폴리 모델링' : 'Low-poly Modeling'}
                            </span>
                            <span className="sub_title other">
                                {lang === 0 ? '하이폴리 모델링' : 'High-poly Modelig'}
                            </span>
                            <span className="sub_title">
                                {lang === 0 ? '리깅, 페인팅 모드' : 'Rigging & Painting Mode'}
                            </span>
                            <span className="sub_title other">
                                {lang === 0 ? 'Pro 전용 확장 기능' : 'Pro Extension Features'}
                            </span>
                            <span className="sub_title btm_last">
                                {lang === 0 ? '100만원 상당의 템플릿 제공' : '$700 worth of Templates'}
                            </span>
                        </div>

                        <div className="price_tab set min">
                            <p className="title top_set">UModeler</p>
                            {/* <span className="sub_title"><img src={images?.option_chk}/></span> */}
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"></span>
                            <span className="sub_title"></span>
                            <span className="sub_title"></span>
                            <span className="sub_title btm_last comment"></span>
                        </div>

                        <div className="price_tab set min">
                            <p className="title top_set">UModeler X<br /> Plus</p>
                            {/* <span className="sub_title"><img src={images?.option_chk}/></span> */}
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"></span>
                            <span className="sub_title btm_last comment"></span>
                        </div>

                        <div className="price_tab right_last set min">
                            <p className="title top_set right_last" style={{ position: 'relative' }}>
                                <img src={require("../assets/icon/pointround.png")} />
                                UModeler X<br /> Pro
                            </p>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title"><img src={images?.option_chk} /></span>
                            <span className="sub_title btm_last comment"><img src={images?.option_chk} /></span>
                        </div>
                    </div>

                    {/* <div className="main_graph_box">
                        <div className="graph">
                            <div className="title_box">
                                <p>UModeler</p>
                                <span>
                                    {lang === 0 ?
                                        <>
                                            로우폴리 모델링 및<br />레벨 디자인을 위한 도구
                                        </>
                                        :
                                        <>
                                            Tools for low-poly modeling and level design
                                        </>
                                    }
                                </span>
                                
                            </div>

                            <div className="shape"></div>
                        </div>

                        <div className="graph plus">
                            <div className="title_box">
                                <p>UModeler X Plus</p>
                                <span>
                                    {lang === 0 ?
                                        <>
                                            하이폴리 모델링과 빠른<br />프로토타이핑을 위한 고급 기능
                                        </>
                                        :
                                        <>
                                            Advanced tools for high-poly modeling and rapid prototyping
                                        </>
                                    }
                                </span>
                            </div>

                            <div className="shape"></div>
                        </div>

                        <div className="graph pro">
                            <div className="title_box">
                                <p>👍 UModeler X Pro</p>
                                <span>
                                    {lang === 0 ?
                                        <>
                                            Pro만의 확장 기능과 팀 라이선스 관리로 교육 및 유니티 3D 프로젝트의 최고의 파트너
                                        </>
                                        :
                                        <>
                                           The best partner for education and Unity 3D projects with Pro-exclusive extension features and team license management
                                        </>
                                    }
                                </span>
                            </div>

                            <div className="shape"></div>
                        </div>
                    </div> */}
                </div>

                <div className="main_part" style={{ background: '#FAFAFA' }}>
                    <div className="title_box partner" style={{ marginBottom: '60px' }}>
                        {lang === 0 ? '투자사 및 파트너' : 'Investors & Partners'}
                    </div>

                    <div className="video_slide_container partner">
                        <div className="video_slide_track partner">
                            {[...Array(partner_top_sample)].map((x, i) => (
                                <div className="video_slide_item partner" key={i}>
                                    <img src={images?.[`logo${i + 1}`]} alt={`slide-${i}`} />
                                </div>
                            ))}

                            {/* {[...Array(partner_top_sample)].map((x, i) => (
                                <div className="video_slide_item partner" key={`clone-${i}`}>
                                    <div className="video_view">
                                        <img src={images?.[`logo${i + 1}`]} alt={`slide-clone${i}`} />
                                    </div>
                                </div>
                            ))} */}
                        </div>

                        <div className="video_slide_track partner sub">
                            {[...Array(partner_top_sample)].map((x, i) => (
                                <div className="video_slide_item partner" key={i}>
                                    <img src={images?.[`logo${i + 7}`]} alt={`slide-${i}`} />
                                </div>
                            ))}

                            {/* {[...Array(partner_top_sample)].map((x, i) => (
                                <div className="video_slide_item partner" key={`clone-${i}`}>
                                    <div className="video_view">
                                        <img src={images?.[`logo${i + 7}`]} alt={`slide-clone${i}`} />
                                    </div>
                                </div>
                            ))} */}
                        </div>
                    </div>
                </div>

            </div> {/* 메인 div */}
            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />

            {popupOpen && (
                <div
                    style={{
                        // 전체 화면 덮는 반투명 배경
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()} // 팝업 내부 클릭 시 닫힘 방지
                    >
                        <CountryLanguagePopup language={language} country={country} onDone={(country, language, marketings) => {
                            let sender = {
                                countryCode: country,
                                emailLanguage: language,
                                id: mbData.idx,
                            };
                            if(marketings !== 'none'){
                                sender.marketings = marketings ? 1 : 0;
                            }
                            API.patch('user/emaillanguage', sender, false).then(({ data }) => {
                                if(marketings !== 'none'){
                                    dispatch(
                                        logIn({
                                            mbData: {
                                                ...mbData,
                                                countryCode: data?.countryCode,
                                                emailLanguage: data?.emailLanguage,
                                                isAcceptMarketingActivities: data?.isAcceptMarketingActivities
                                            },
                                        })
                                    );
                                } else {
                                    dispatch(
                                        logIn({
                                            mbData: {
                                                ...mbData,
                                                countryCode: data?.countryCode,
                                                emailLanguage: data?.emailLanguage,
                                            },
                                        })
                                    );
                                }

                            }).catch(err => {
                                console.log(err.response.data)
                            });
                            setPopupOpen(false);
                        }} />
                    </div>
                </div>
            )}
        </>
    );
}
